import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.display_name || u.email}`);
      if (u.role === "admin") nav("/admin");
      else if (u.role === "syndicate_owner" || u.role === "gm" || u.role === "moderator") nav("/team-admin");
      else nav("/profile");
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.detail?.includes("verify")) {
        toast.error("Racer terminal not verified. Please verify your account first.");
        localStorage.setItem("rtrl_verify_email", email);
        nav("/verify", { state: { email } });
      } else {
        toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
      }
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="rtrl-card carbon-bg p-8">
        <div className="small-label text-rtrl-red">Access Terminal</div>
        <h1 className="font-display uppercase text-5xl text-white mt-2">Log In</h1>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="small-label">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rtrl-input" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="small-label">Password</label>
              <Link to="/forgot-password" className="text-xs font-mono-tech text-rtrl-red hover:underline" data-testid="login-forgot-pwd">Forgot Password?</Link>
            </div>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rtrl-input" />
          </div>
          <button data-testid="login-submit" disabled={busy} className="rtrl-btn w-full justify-center">{busy ? "…" : "Log In"}</button>
        </form>

        <div className="mt-6 flex items-center justify-between gap-2">
          <div className="h-px bg-surface-line flex-1"></div>
          <span className="small-label text-white/40">OR</span>
          <div className="h-px bg-surface-line flex-1"></div>
        </div>

        <button
          onClick={() => {
            // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
            const redirectUrl = window.location.origin + "/login";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
          className="mt-4 rtrl-btn-ghost w-full justify-center gap-2 border border-surface-line hover:border-white/20"
          data-testid="google-auth-btn"
        >
          <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
            <path d="M12.24 10.285V14.4h6.887c-.648 2.41-2.519 4.114-5.136 4.114-3.51 0-6.357-2.847-6.357-6.357s2.847-6.357 6.357-6.357c1.5 0 2.873.515 3.96 1.39l3.079-3.08A11.91 11.91 0 0012.24 2c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.244 0 11.517-4.36 12-10.285H12.24z"/>
          </svg>
          Sign in with Google
        </button>

        <div className="mt-6 small-label">
          New racer? <Link to="/register" className="text-rtrl-red">Register here</Link>.
        </div>
      </div>
    </div>
  );
}
